import React from 'react';

import { flagStyles } from '../settings';

const SvgUS = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-5496px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgUS;
